import React from 'react';
import {
  Box,
  Button,
  ChevronLeftIcon,
  Heading,
  Link,
  Menu,
  MenuItem,
  MenuOverlay,
  MoreHorizontalIcon,
} from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';

interface TimeAndAttendanceHeaderProps {
  onDisableClick: () => void;
}

export const TimeAndAttendanceHeader = ({ onDisableClick }: TimeAndAttendanceHeaderProps) => {
  return (
    <Box>
      <Link
        icon={ChevronLeftIcon}
        iconPosition="left"
        onClick={() => {
          window.location.href = routePaths.phpRoutes.companySettings;
        }}
        marginBottom="spacing.6">
        Back to Settings
      </Link>
      <Box display="flex" alignItems="flex-start" justifyContent="space-between">
        <Box>
          <Heading size="xlarge">Time &amp; Attendance</Heading>
        </Box>

        <Menu openInteraction="click">
          <Button
            variant="tertiary"
            icon={MoreHorizontalIcon}
            accessibilityLabel="More actions"
            onClick={() => undefined}
          />
          <MenuOverlay maxWidth="280px">
            <MenuItem
              title="Disable time and attendance"
              description="Disabling stops attendance, leaves, and overtime for your entire organisation from the next pay cycle."
              color="negative"
              onClick={onDisableClick}
            />
          </MenuOverlay>
        </Menu>
      </Box>
    </Box>
  );
};
